import { render, staticRenderFns } from "./AnswerTwoSetting.vue?vue&type=template&id=14163ee9&"
import script from "./AnswerTwoSetting.vue?vue&type=script&lang=js&"
export * from "./AnswerTwoSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports